import { render, staticRenderFns } from "./ChatInviteDialog.vue?vue&type=template&id=8afbcfe0&scoped=true&"
import script from "./ChatInviteDialog.vue?vue&type=script&lang=js&"
export * from "./ChatInviteDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChatInviteDialog.vue?vue&type=style&index=0&id=8afbcfe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afbcfe0",
  null
  
)

export default component.exports